import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppRoutesName } from '../../const/AppRoutesName';
import { CanDeactivateGuard } from '../../gards/can-deactivate-guard.service';

export const routes: Routes = [
  {
    path: ':shop_uuid/' + AppRoutesName.FR.SHOPS,
    loadComponent: () =>
      import('./shops.component').then((m) => m.ShopsComponent),
  },
  {
    path: ':shop_uuid/' + AppRoutesName.FR.SHOPS + '/shop-web/:slug/:id',
    loadComponent: () =>
      import('./shop-web-detailed/shop-web-detailed.component').then(
        (m) => m.ShopWebDetailedComponent,
      ),
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path:
      ':shop_uuid/' + AppRoutesName.FR.SHOPS + '/shop-web-detailed/:slug/:id',
    loadComponent: () =>
      import('./shop-web-detailed/shop-web-detailed.component').then(
        (m) => m.ShopWebDetailedComponent,
      ),
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path:
      ':shop_uuid/' +
      AppRoutesName.FR.SHOPS +
      '/shop-web-detailed/:slug/:id/:section',
    loadComponent: () =>
      import('./shop-web-detailed/shop-web-detailed.component').then(
        (m) => m.ShopWebDetailedComponent,
      ),
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: ':shop_uuid/' + AppRoutesName.FR.SHOPS + '/shop-internal/:slug/:id',
    loadComponent: () =>
      import('./internal-shop/internal-shop.component').then(
        (m) => m.InternalShopComponent,
      ),
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path:
      ':shop_uuid/' +
      AppRoutesName.FR.SHOPS +
      '/shop-internal/:slug/:id/:section',
    loadComponent: () =>
      import('./internal-shop/internal-shop.component').then(
        (m) => m.InternalShopComponent,
      ),
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: ':shop_uuid/' + AppRoutesName.EN.SHOPS,
    loadComponent: () =>
      import('./shops.component').then((m) => m.ShopsComponent),
  },
  {
    path: ':shop_uuid/' + AppRoutesName.EN.SHOPS + '/shop-web/:slug/:id',
    loadComponent: () =>
      import('./shop-web-detailed/shop-web-detailed.component').then(
        (m) => m.ShopWebDetailedComponent,
      ),
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path:
      ':shop_uuid/' + AppRoutesName.EN.SHOPS + '/shop-web-detailed/:slug/:id',
    loadComponent: () =>
      import('./shop-web-detailed/shop-web-detailed.component').then(
        (m) => m.ShopWebDetailedComponent,
      ),
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path:
      ':shop_uuid/' +
      AppRoutesName.EN.SHOPS +
      '/shop-web-detailed/:slug/:id/:section',
    loadComponent: () =>
      import('./shop-web-detailed/shop-web-detailed.component').then(
        (m) => m.ShopWebDetailedComponent,
      ),
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: ':shop_uuid/' + AppRoutesName.EN.SHOPS + '/shop-internal/:slug/:id',
    loadComponent: () =>
      import('./internal-shop/internal-shop.component').then(
        (m) => m.InternalShopComponent,
      ),
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path:
      ':shop_uuid/' +
      AppRoutesName.EN.SHOPS +
      '/shop-internal/:slug/:id/:section',
    loadComponent: () =>
      import('./internal-shop/internal-shop.component').then(
        (m) => m.InternalShopComponent,
      ),
    canDeactivate: [CanDeactivateGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ShopsModule {}
